export const DocumentTypePolicy = ({

    INVOICE_TYPE : "IN",
    CREDIT_NOTE_TYPE : "CN"
   
})
